import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LandingPage } from "../pages/landing/landing";
import { LoginPage } from "../pages/login/login";
import { UserService } from '../providers/session-service/user-service';
import { SettingsPage } from "../pages/settings/settings";
import { RegisterPage } from "../pages/register/register";
import { CMService } from '../providers/cm-service/cm-service';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { HttpModule } from '@angular/http';
import { PostsPage } from "../pages/posts/posts";
import { MapPage } from "../pages/map/map";
import { Geolocation } from '@ionic-native/geolocation';
import { TeamPage } from "../pages/team/team";
import { SanitizeHtmlPipe } from '../pipes/sanitize-html/sanitize-html';
import { TeamShowcasePage } from "../pages/team-showcase/team-showcase";
import { IonicImageViewerModule } from "ionic-img-viewer";
import { GalleryPage } from "../pages/gallery/gallery";
import { BoutiquePage } from "../pages/boutique/boutique";
import { PostDetailsPage } from "../pages/post-details/post-details";
import { SponsorsPage } from "../pages/sponsors/sponsors";
import { SchedulePage } from "../pages/schedule/schedule";
import { ScoreboardPage } from "../pages/scoreboard/scoreboard";
import { BrowserTab } from '@ionic-native/browser-tab';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { LocationAccuracy } from '@ionic-native/location-accuracy';
import { Diagnostic } from '@ionic-native/diagnostic';
import { OneSignal } from '@ionic-native/onesignal';
import { CallNumber } from '@ionic-native/call-number';
import { NotificationsPage } from '../pages/notifications/notifications';

export const firebaseConfig = {
    apiKey: "AIzaSyB4qUWwQNwV_RVE9RNv55PQlNEnekbu_iU",
    authDomain: "navarxos-botsis-basketball.firebaseapp.com",
    databaseURL: "https://navarxos-botsis-basketball.firebaseio.com",
    projectId: "navarxos-botsis-basketball",
    storageBucket: "navarxos-botsis-basketball.appspot.com",
    messagingSenderId: "60836488329"
};

@NgModule({
    declarations: [
        MyApp,
        HomePage,
        LandingPage,
        LoginPage,
        SettingsPage,
        RegisterPage,
        PostsPage,
        PostDetailsPage,
        MapPage,
        TeamPage,
        TeamShowcasePage,
        GalleryPage,
        BoutiquePage,
        SponsorsPage,
        SchedulePage,
        ScoreboardPage,
        NotificationsPage,
        SanitizeHtmlPipe
    ],
    imports: [
        IonicImageViewerModule,
        HttpModule,
        BrowserModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireAuthModule,
        AngularFirestoreModule,
        AngularFireDatabaseModule,
        IonicModule.forRoot(MyApp, {
            appVersion: '2.0.1',
            appVersionCheckCode: 2001
        }),
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage,
        LandingPage,
        LoginPage,
        SettingsPage,
        RegisterPage,
        PostsPage,
        PostDetailsPage,
        MapPage,
        TeamPage,
        GalleryPage,
        BoutiquePage,
        SponsorsPage,
        SchedulePage,
        ScoreboardPage,
        TeamShowcasePage,
        NotificationsPage
    ],
    providers: [
        StatusBar,
        Geolocation,
        SplashScreen,
        {
            provide: ErrorHandler, useClass: IonicErrorHandler
        },
        UserService,
        CMService,
        InAppBrowser,
        BrowserTab,
        LocationAccuracy,
        Diagnostic,
        OneSignal,
        CallNumber
    ]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts